"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDeveloperFieldFiltering = void 0;
var PropertyTypes_1 = require("../../constants/SearchPageCategories/PropertyTypes");
var RealEstate_1 = require("../../constants/SearchPageCategories/RealEstate");
var FromDeveloper_1 = require("../../constants/SearchPageCategories/FromDeveloper");
var DeveloperType_1 = require("../../types/SearchPage/DeveloperType");
var StructureTypes_1 = require("../../constants/SearchPageCategories/StructureTypes");
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var makeDeveloperFieldFiltering = function (value, isDeveloperQuery, setIsDeveloperQuery, propertyTypeQuery, roomsQuery, structureTypeQuery, replacePageURL, currentLanguage, deal) {
    if (value === DeveloperType_1.DEVELOPER_TYPE.True && isUndefined_1.default(isDeveloperQuery[0])) {
        setIsDeveloperQuery([value]);
    }
    if (value === isDeveloperQuery[0] &&
        isDeveloperQuery[0] === DeveloperType_1.DEVELOPER_TYPE.True) {
        setIsDeveloperQuery([]);
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length)) {
            replacePageURL(PropertyTypes_1.PROPERTY_TYPES[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            (structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length)) {
            replacePageURL(StructureTypes_1.STRUCTURE_TYPES[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if (!(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !(propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length)) {
            replacePageURL(RealEstate_1.REAL_ESTATE[currentLanguage].REAL_ESTATE);
        }
    }
    else if (value === DeveloperType_1.DEVELOPER_TYPE.True) {
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length)) {
            replacePageURL(FromDeveloper_1.FromDeveloperTypes[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if ((propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length) &&
            (structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length)) {
            replacePageURL(FromDeveloper_1.DeveloperWithStructurePropertyType[currentLanguage][deal][propertyTypeQuery[0]]);
        }
        if (!(roomsQuery === null || roomsQuery === void 0 ? void 0 : roomsQuery.length) &&
            !(structureTypeQuery === null || structureTypeQuery === void 0 ? void 0 : structureTypeQuery.length) &&
            !(propertyTypeQuery === null || propertyTypeQuery === void 0 ? void 0 : propertyTypeQuery.length)) {
            replacePageURL(RealEstate_1.REAL_ESTATE[currentLanguage].DEVELOPER_REAL_ESTATE);
        }
    }
};
exports.makeDeveloperFieldFiltering = makeDeveloperFieldFiltering;
